import { create } from 'zustand';

export interface SelfieState {
  selfie: string;
  setSelfie: (selfie: string) => void;
  allowNextForced: boolean;
  setAllowNextForced: (val: boolean) => void;
}

const useSelfieStore = create<SelfieState>((set) => ({
  selfie: '',
  allowNextForced: false,

  setSelfie: (val: string) =>
    set(() => ({
      selfie: val
    })),
  setAllowNextForced: (val: boolean) => set(() => ({ allowNextForced: val }))
}));

export { useSelfieStore };
